import React from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    IconButton,
    MenuItem,
    Switch,
    TextField,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import Grid2 from "@mui/material/Grid2";
import { TAX_RATES } from "./shippingCostUtils";

const ShippingCostFormDialog = ({
    open,
    shippingCost,
    fieldErrors,
    gross,
    onClose,
    onFieldChange,
    onToggleActive,
    onSave,
}) => (
    <Dialog
        open={open}
        onClose={onClose}
        fullWidth
        maxWidth="sm"
        PaperProps={{ sx: { borderRadius: 3 } }}
    >
        <DialogTitle>
            {shippingCost.id ? "Versandkosten bearbeiten" : "Versandkosten hinzufügen"}
            <IconButton
                aria-label="Schließen"
                onClick={onClose}
                sx={{ position: "absolute", right: 8, top: 8 }}
            >
                <CloseRoundedIcon />
            </IconButton>
        </DialogTitle>
        <DialogContent dividers>
            <Grid2 container spacing={2}>
                <Grid2 xs={12}>
                    <TextField
                        label="Bezeichnung"
                        value={shippingCost.name}
                        onChange={(event) => onFieldChange("name", event.target.value)}
                        fullWidth
                        required
                        error={Boolean(fieldErrors.name)}
                        helperText={fieldErrors.name || ""}
                    />
                </Grid2>

                <Grid2 xs={12} sm={6}>
                    <TextField
                        label="Nettopreis"
                        type="number"
                        value={shippingCost.price}
                        onChange={(event) => onFieldChange("price", event.target.value)}
                        fullWidth
                        inputMode="decimal"
                        inputProps={{ step: "0.01", min: "0" }}
                        error={Boolean(fieldErrors.price)}
                        helperText={fieldErrors.price || ""}
                    />
                </Grid2>

                <Grid2 xs={12} sm={6}>
                    <TextField
                        select
                        label="Steuersatz (%)"
                        value={shippingCost.taxRate}
                        onChange={(event) => onFieldChange("taxRate", event.target.value)}
                        fullWidth
                        error={Boolean(fieldErrors.taxRate)}
                        helperText={fieldErrors.taxRate || ""}
                    >
                        {TAX_RATES.map((taxRate) => (
                            <MenuItem key={taxRate} value={taxRate}>
                                {taxRate} %
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid2>

                <Grid2 xs={12} sm={6}>
                    <TextField
                        label="Brutto (automatisch)"
                        value={Number.isFinite(gross) ? gross.toFixed(2) : ""}
                        fullWidth
                        disabled
                    />
                </Grid2>

                <Grid2 xs={12} sm={6} sx={{ display: "flex", alignItems: "center" }}>
                    <FormControlLabel
                        control={<Switch checked={Boolean(shippingCost.active)} onChange={onToggleActive} />}
                        label="Aktiv"
                    />
                </Grid2>
            </Grid2>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
            <Button onClick={onClose}>Abbrechen</Button>
            <Button
                onClick={onSave}
                variant="contained"
                sx={{ bgcolor: "orange", "&:hover": { bgcolor: "#cc7a00" }, borderRadius: 2, color: "#000" }}
            >
                Speichern
            </Button>
        </DialogActions>
    </Dialog>
);

export default ShippingCostFormDialog;
